import React from "react";
import { Link } from "react-router-dom";

const EMAIL = "hello@build-partner.de";

export const Footer = () => {
  return (
    <footer
      className="border-t border-slate-200 bg-white"
      data-testid="site-footer"
    >
      <div className="bp-container py-10 sm:py-12 flex flex-col sm:flex-row items-center justify-between gap-4">
        <a
          href={`mailto:${EMAIL}`}
          className="text-sm text-slate-600 hover:text-[#0A2540] transition-colors"
          data-testid="footer-email-link"
        >
          {EMAIL}
        </a>
        <div className="flex items-center gap-6">
          <span className="text-xs text-slate-400">
            © {new Date().getFullYear()} Build Partner
          </span>
          <Link
            to="/impressum"
            className="text-sm text-slate-600 hover:text-[#0A2540] transition-colors"
            data-testid="footer-impressum-link"
          >
            Impressum
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
